import sanitizeHtml from "sanitize-html";

// Wraps every case-insensitive occurrence of `query` in `text` with <em> tags.
// Returns a sanitized HTML string safe for dangerouslySetInnerHTML.
// When query is empty the text is returned sanitized but without any wrapping.
const highlightText = (text: string, query: string): string => {
  if (!text) return "";
  if (!query.trim()) return sanitizeHtml(text);
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const wrapped = text.replace(new RegExp(`(${escaped})`, "gi"), "<em>$1</em>");
  return sanitizeHtml(wrapped);
};

export default highlightText;
